import React from "react";
import { Link } from "react-router-dom";

import CatalogueImage from "../../assets/images/catalogue1.jpg";

function CatalogueCard({ catalogue, purchase, purchases = [], onSelect }) {
	const {
		name = "Untitled catalogue",
		description,
		image_file: imageFile,
		report_count: reportCount,
	} = catalogue;
	const purchaseHistory = purchases.length ? purchases : purchase ? [purchase] : [];
	const isPurchased = purchaseHistory.length > 0;
	const readyPurchases = purchaseHistory.filter((item) => item.status === "completed" || item.report_file);
	const viewablePurchase = readyPurchases.find((item) => item.id);
	const pendingCount = purchaseHistory.length - readyPurchases.length;
	const purchasedLotCount = purchaseHistory.reduce(
		(total, item) => total + (Number(item.lot_count) || 0),
		0
	);
	const canBuyMore = reportCount == null || purchasedLotCount < reportCount;
	const isPreparing = pendingCount > 0;
	const lotCount = reportCount;
	const statusLabel = !isPurchased
		? "Available"
		: isPreparing
			? "Purchased · Preparing"
			: "Purchased · Ready";

	return (
		<article className={`catalogue-list-item${isPurchased ? " is-purchased" : ""}`}>
			<div className="catalogue-list-item__image">
				<img src={imageFile || CatalogueImage} alt="" />
			</div>
			<div className="catalogue-list-item__content">
				<div className="catalogue-list-item__title-row">
					<div>
						<span className={`catalogue-status catalogue-status--${isPurchased ? (isPreparing ? "pending" : "ready") : "available"}`}>
							<i className={`fa ${isPurchased ? (isPreparing ? "fa-clock" : "fa-check-circle") : "fa-book-open"}`} aria-hidden="true" />
							{statusLabel}
						</span>
						<h3>{name}</h3>
					</div>
					{lotCount != null ? <span className="catalogue-list-item__lots">{lotCount} lots</span> : null}
				</div>
				<p>{description || "Auction-lot pedigree analysis and performance insights."}</p>
				<div className="catalogue-list-item__meta">
					{isPurchased ? (
						<span><i className="fa fa-lock-open" aria-hidden="true" /> {purchasedLotCount} of {reportCount ?? "the"} lots purchased</span>
					) : (
						<span><i className="fa fa-coins" aria-hidden="true" /> 1 credit per paid lot</span>
					)}
				</div>
			</div>
			<div className="catalogue-list-item__action">
				{viewablePurchase ? <Link to={`/reports/collections/catalogue/${viewablePurchase.id}`} aria-label={`View ${name} report`} title="View and compare horses"><i className="fa fa-eye" aria-hidden="true" /> View report & compare</Link> : null}
				{pendingCount ? (
					<span className="catalogue-list-item__pending">
						<i className="fa fa-clock" aria-hidden="true" /> {pendingCount} report{pendingCount === 1 ? "" : "s"} preparing
					</span>
				) : null}
				{!isPurchased || canBuyMore ? (
					<button type="button" onClick={() => onSelect(catalogue)}>
						{isPurchased ? "Buy more lots" : "Browse lots"} <i className="fa fa-arrow-right" aria-hidden="true" />
					</button>
				) : null}
			</div>
		</article>
	);
}

export default CatalogueCard;
